import { type AxiosRequestConfig } from 'axios';

import getSessionId from '@/helpers/getSessionId';
import isBrowser from '@/helpers/isBrowser';

type AxiosInterceptor = {
  onFulfilled: (config: AxiosRequestConfig<any>) => AxiosRequestConfig<any>;
  onRejected?: (error: any) => any;
};

const addSessionIdToHeader: AxiosInterceptor = {
  onFulfilled: (config): AxiosRequestConfig => {
    if (isBrowser()) {
      if (!config.headers) {
        config.headers = {};
      }

      config.headers['x-sessionId'] = getSessionId();
    }
    return config;
  },
};

const interceptors = { addSessionIdToHeader };

export default interceptors;
